import React from 'react';
import useGetMapData from './useGetMapData';
import useTranslate from '../../../../../common/hooks/useTranslate';
import { useInternationalization } from '@progress/kendo-react-intl';

import { IWidget } from '../../../types/IWidget';

import { Map, MapBubbleLayer, MapBubbleLayerTooltip, MapLayers, MapTileLayer } from '@progress/kendo-react-map';
import WidgetTitle from '../widgetTitle/widgetTitle';
import OutletLoader from '../../../../ui/loaders/outletLoader/outletLoader';
import { DropDownList } from '@progress/kendo-react-dropdowns';

import './mapWidget.scss';

const MapWidget: React.FC<IWidget> = ({
                                        setup,
                                        widget,
                                        measures,
                                        scenarios,
                                        onExpand,
                                        onCollapse,
                                        expand,
                                        notes,
                                        boardId,
                                        id,
                                        staticProperties,
                                        widgets,
                                        handleWidgetChange,
                                        changeOldIndex,
                                        handleWidgetMove,
                                        changeNewIndex,
                                        customisation,
                                        selectedPeriod,
                                        selectedObject,
                                        boardSelectedCurrency,
                                        investorObjectId,
                                        homePage,
                                        handleUnpin,
                                        handlePinWidget,
                                        handleUnpinWidget,
                                        unpinId,
                                      }) => {
  const {
    lat,
    long,
    zoom,
    loading,
    currencies,
    handleCurrencyChange,
    selectedCurrency,
    values,
    tileUrl,
    attribution,
    selectData,
    onSelectChange,
    tileSubdomains,
    bubbleStyle,
  } = useGetMapData(setup, widget, measures, notes, boardId, staticProperties, scenarios, selectedObject, selectedPeriod, boardSelectedCurrency, investorObjectId);

  const { t } = useTranslate();
  const intl = useInternationalization();
  const center = [lat, long];

  const renderBubbleTooltip = (props) => (
    <div>
      <span>{props.dataItem.name}</span><br />
      <span>{props.dataItem.measureName}: {intl.toString(props.dataItem.value, `n${props.dataItem.scale}`)}</span>
    </div>
  );

  const preventFromZoom = (e) => {
    if (e.originalEvent && e.originalEvent.type && e.originalEvent.wheelDelta) {
      e.preventDefault();
    }
  };

  return (
    loading ? <OutletLoader /> :
      <>
        <WidgetTitle currencySelection={(widget.pinned === null || widget.setup.currencySelection) ? currencies : false}
                     selectedCurrency={selectedCurrency}
                     handleCurrencyChange={handleCurrencyChange} name={widget.name} type={widget.type}
                     onExpand={onExpand} onCollapse={onCollapse} expand={expand}
                     id={id} customisation={customisation}
                     widgets={widgets}
                     handleWidgetChange={handleWidgetChange}
                     handleWidgetMove={handleWidgetMove}
                     changeNewIndex={changeNewIndex}
                     changeOldIndex={changeOldIndex}
                     widget={widget}
                     selectedObject={selectedObject}
                     homePage={homePage}
                     investorId={investorObjectId}
                     handleUnpin={handleUnpin}
                     handlePinWidget={handlePinWidget}
                     handleUnpinWidget={handleUnpinWidget}
                     unpinId={unpinId}
        />
        <div className='view-by-dropdown-wrapper'>
          <span className='view-by-dropdown-label'>{t('WIDGET.VIEW_BY')}</span>
          <DropDownList data={selectData} defaultValue={selectData[0]} onChange={onSelectChange} textField='name'
                        dataItemKey='measureId' />
        </div>
        <Map className='map-container' center={center} zoom={zoom} onZoomStart={preventFromZoom}>
          <MapLayers>
            <MapTileLayer
              urlTemplate={tileUrl}
              subdomains={tileSubdomains}
              attribution={attribution}
            />
            <MapBubbleLayer
              data={values}
              locationField='location'
              valueField='value'
              style={bubbleStyle}
            >
              <MapBubbleLayerTooltip render={renderBubbleTooltip} />
            </MapBubbleLayer>
          </MapLayers>
        </Map>
      </>
  );
};
export default MapWidget;
